import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root' 
})
export class RouteDataProvider {

    public storage: any;

    public constructor() { }
}